import type { CommerceHttpAdapter } from '../../client/CommerceHttpAdapter.js'
import type { CacheStrategy } from '../../workers/CacheStrategy.js'
import type { MarketingItem } from '../../types/index.js'

export class MarketingModule {
  constructor(
    private readonly http: CommerceHttpAdapter,
    private readonly cache: CacheStrategy
  ) {}

  /** Récupère un item marketing par son code */
  getItem(code: string): Promise<MarketingItem> {
    return this.cache.execute(
      `marketing:item:${code}`,
      () => this.http.get<MarketingItem>(`/commerce/api/marketing/items/${encodeURIComponent(code)}`),
      'stale-while-revalidate'
    )
  }

  /** Récupère plusieurs items marketing par leurs codes */
  getItems(codes: string[]): Promise<MarketingItem[]> {
    const key = `marketing:items:${codes.sort().join(',')}`
    return this.cache.execute(
      key,
      () => this.http.post<MarketingItem[]>('/commerce/api/marketing/items/batch', { codes }),
      'stale-while-revalidate'
    )
  }
}
